import { ConfigManager } from '~/managers/ConfigManager'

export async function importRoutes() {
  let module
  if (ConfigManager.isAppSite()) {
    module = await import(`~/app/routes/config`)
  } else {
    module = await import(`~/biz/routes/config`)
  }
  return module.default
}
